import { render, staticRenderFns } from "./work_experiences_tab.vue?vue&type=template&id=3b8dcced&scoped=true"
import script from "./work_experiences_tab.vue?vue&type=script&lang=js"
export * from "./work_experiences_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8dcced",
  null
  
)

export default component.exports